import { render, staticRenderFns } from "./TcmPrintInvoices.vue?vue&type=template&id=bd318f66&"
import script from "./TcmPrintInvoices.vue?vue&type=script&lang=js&"
export * from "./TcmPrintInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports